module.exports = __webpack_public_path__ + "img/stepup.15f5e281.png";